import { Col, Row } from 'antd';
import moment from 'moment';
import { useAgendarCita } from 'pages/AgendarCita/AgendarCitaContext';
import { formatTime, I18nt } from 'utils';
import styles from './confirm.module.less';

const Confirm = () => {
	const { 
    selectedClinic,
    selectedDate,
    patient,
    selectedTime,
    isSpecialist,
    selectedCategory,
    selectedDoctor,
    phone,
    dispatch,
  } = useAgendarCita();

  const setPhone = (e: React.ChangeEvent<HTMLInputElement>) => {
    if(e.target.value.length > 9) return;
    dispatch({ type: 'setPhone', payload: e.target.value });
  };

  const displayPlaceInfo = () => {
    if (isSpecialist) {
      return (
        <>
          <p>
            {I18nt('medico')}:{' '}
            <span className={styles.textBase}>
              {selectedDoctor?.nombreMedico}
            </span>
          </p>
          <p>
            {I18nt('especialidad')}:{' '}
            <span className={styles.textBase}>
              {selectedCategory?.nombreEspecialidad}
            </span>
          </p>
          <p>
            {I18nt('lugar')}:{' '}
            <span className={styles.textBase}>
              {selectedDoctor?.nombreEstablecimiento}
            </span>
          </p>
        </>
      );
    }
    return (
      <p>
        {I18nt('lugar')}:{' '}
        <span className={styles.textBase}>
          {selectedClinic?.establecimiento}
        </span>
      </p>
    );
  };

	const formattedDate = moment(selectedDate, 'YYYY-MM-DD').format('DD-MM-YYYY');
	return (
		<Row justify='center'>
			<Col xs={24} lg={12}>
				<section className={styles.dataSection}>
					<div className={styles.title}>{I18nt('confirmar_cita')}</div>
					<div className={styles.infoContainer}>
						<div className={styles.infoBox}>
							<p>
								{I18nt('paciente')}
								{': '}
								<span
									className={styles.textBase}
								>{`${patient?.nombrePaciente} ${patient?.apellidoPaciente}`}</span>
							</p>
							<p>
								{I18nt('numero_de_afiliación')}:{' '}
								<span>{patient?.numeroAfiliado}</span>
							</p>
							<p>
								{I18nt('dui')}: <span>{patient?.dui}</span>
							</p>
              {displayPlaceInfo()}
							<p>
								{I18nt('fecha')}:{' '}
								<span className={styles.textBase}>{formattedDate}</span>
							</p>
							<p>
								{I18nt('hora')}:{' '}
								<span className={styles.textBase}>
									{formatTime(selectedTime)}
								</span>
							</p>
							<div className={styles.instructionCont}>
								<p>{I18nt('indicaciones')}</p>
								<p>
									<span className={styles.textBase}>
										{I18nt('confirm_instrunctions')}
									</span>
								</p>
							</div>
						</div>
					</div>
          {isSpecialist ? 
            <div className={styles.phoneContainer}>
              <p>{I18nt('dejanos_tu_telefono')}:</p>
              <label><sup>*</sup> {I18nt('numero_de_telefono')}:</label>
              <input type="tel" onChange={setPhone} value={phone} />
            </div>
            : null
          }
				</section>
			</Col>
		</Row>
	);
};

export default Confirm;
